<template>
  <div class="setting-wrapper">
    <p class="small accent">
      {{ t('screen_color') }}
    </p>
    <ButtonRadio v-model:model="modelValue" :options="optionsBackgroundColor" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import ButtonRadio from '@/components/shared/base/ButtonRadio.vue';
import { useUserStore } from '@/stores/user';

const { t } = useI18n();
const userStore = useUserStore();

const props = withDefaults(defineProps<{ isGlobal: boolean }>(), {
  isGlobal: false,
});

const modelValue = defineModel<string>({
  default: 'GREEN',
  set(newVal) {
    if (props.isGlobal) {
      userStore.updateUserPreferences({ setting: 'subtitleBackgroundColor', newVal });
    }

    return newVal;
  },
});

const optionsBackgroundColor = computed(() => {
  return [
    { label: 'BLACK', value: 'BLACK' },
    { label: 'GREEN', value: 'GREEN' },
  ];
});
</script>

<style scoped lang="scss">
:deep(.setting-wrapper) {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  justify-content: space-between;
  white-space: nowrap;
}
</style>
